module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-vault-3.99722c66.svg";